import React from 'react'
import SbEditable from 'storyblok-react'
import Helmet from 'react-helmet'

import Components from './../Components'

import styles from './styles.module.scss'

const Page = (props) => {
    return (
        <SbEditable content={props.blok}>
            <Helmet
                title={props.blok.metadata.title || props.blok.title}
                meta={[
                    { 
                        name: 'title', 
                        content: `${props.blok.metadata.title || props.blok.title}`
                    },
                    { 
                        name: 'description', 
                        content: `${props.blok.metadata.description || ''}`
                    },
                    { 
                        name: 'keywords', 
                        content: `${props.blok.metadata.keywords || ''}`
                    },
                    { 
                        name: 'image', 
                        content: `https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg`
                    },
                    { 
                        name: 'twitter:title', 
                        content: `${props.blok.metadata.title || props.blok.title}`
                    },
                    { 
                        name: 'twitter:description', 
                        content: `${props.blok.metadata.description || ''}`
                    },
                    { 
                        name: 'twitter:keywords', 
                        content: `${props.blok.metadata.keywords || ''}`
                    },
                    { 
                        name: 'twitter:card', 
                        content: `summary_large_image`
                    },
                    { 
                        name: 'twitter:image', 
                        content: `https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg`
                    },
                    { 
                        name: 'og:title', 
                        content: `${props.blok.metadata.title || props.blok.title}`
                    },
                    { 
                        name: 'og:description', 
                        content: `${props.blok.metadata.description || ''}`
                    },
                    { 
                        name: 'og:keywords', 
                        content: `${props.blok.metadata.keywords || ''}`
                    },
                    { 
                        name: 'og:image', 
                        content: `https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg`
                    },
                    { 
                        name: 'image', 
                        property: 'og:image',
                        content: `https://a.storyblok.com/f/95584/1200x630/e048a53f5c/seo-image.jpg`
                    }
                ]}
            />
            {props.blok.body ? props.blok.body.map((blok) => 
                React.createElement(Components(blok.component), {key: blok._uid, blok: blok})
            ) : (
                <div className={styles['page__add-components']}>
                    <p className='body'>Please add some components..</p>
                </div>
            )}
        </SbEditable>
    )
}

export default Page